namespace $.$$ {
	export class $shm_hitalama_select_list extends $.$shm_hitalama_select_list {
		
		Pick(): $.$mol_select {
			const obj = super.Pick()
			obj.Filter().Clear = ()=> this.Add_option()
			obj.Filter().hint = ()=> 'Поиск или новый...'
			obj.Filter().Query().submit_with_ctrl = ()=> true
			obj.submit = ()=> this.add_option()
			obj.option_content = (id) => {
				return [
					obj.Option_label(id),
					...(id == '') ? [] : [this.Option_delete(id)],
				]
			}
			obj.trigger_content = () => [ obj.Trigger_icon() ]
			return obj
		}

		add_option( next?: any ) {
			const text = this.Pick().filter_pattern()
			this.options( [...this.options(), text] )
			this.value( [...this.value(), text] )
			this.Pick().showed(false)
			this.Pick().filter_pattern('')
		}

		delete( id: any ) {
			this.options( [...this.options().filter( o => o != id )] )
		}
		
		@ $mol_mem
		options( next?: string[] ) {
			return next ?? []
		}

		option_title( key : string ) {
			return key
		}
		
	}
}
